import * as React from 'react';
import type { SVGProps } from 'react';
const SvgClock = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 24 24" {...props}>
    <circle cx={12} cy={12} r={7.25} stroke="currentColor" strokeWidth={1.5} />
    <path stroke="currentColor" strokeWidth={1.5} d="M12 8v4l2 2" />
  </svg>
);
export default SvgClock;
